"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Exchange = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Item = require("./Item");
var _AmountData = require("./AmountData");
var _ValueWhenTransacted = require("./ValueWhenTransacted");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Exchange = function Exchange(_ref) {
  var _transaction$target, _transaction$target2;
  var transaction = _ref.transaction;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransaction', 'libTransactionsTable']),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.exchange')
  }, transaction.ticker, " ", t('libTransactionsTable:to'), " ", (_transaction$target = transaction.target) === null || _transaction$target === void 0 ? void 0 : _transaction$target.ticker), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.amount')
  }, /*#__PURE__*/_react.default.createElement(_AmountData.AmountData, {
    value: transaction.amount.value,
    convertedValue: transaction.target.amount,
    convertedTicker: (_transaction$target2 = transaction.target) === null || _transaction$target2 === void 0 ? void 0 : _transaction$target2.ticker,
    ticker: transaction.ticker
  })), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.price')
  }, /*#__PURE__*/_react.default.createElement(_ValueWhenTransacted.ValueWhenTransacted, {
    price: transaction.exchangePrice.value,
    ticker: transaction.exchangePrice.pair[0],
    convertedTicker: transaction.exchangePrice.pair[1]
  })));
};
exports.Exchange = Exchange;